import React, { useState, useEffect, useCallback } from "react";
import "../Reperti.scss";
import DataTableSubHeader from "../../../Components/DataTableSubHeader/DataTableSubHeader.jsx";
import { useLocation, useNavigate } from "react-router-dom";
import {
  AddIcon,
  CrossIcon,
  EditIcon,
  RightArrowIcon,
} from "../../../assets/icons/index.js";
import { SubHeaderMobileOption } from "../../../Components/SubHeaderMobileOption/SubHeaderMobileOption.jsx";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  getReperto,
  updateReperto,
  saveRepertoImg,
  updateRepertoEsposizione,
} from "../../../api/index.js";
import { validateReperto } from "../../../helpers/formTools/validations/repertorio/index.js";
import { useAppContext } from "../../../Components/Context/AppContext.jsx";
import RepertiRecordDetailForm from "../../../Components/Reperti/EditReperto/RepertiRecordDetailForm/RepertiRecordDetailForm.jsx";
import userHasPermission from "../../../helpers/formTools/userHasPermission/index.js";
import Spinner from "../../../Components/ProgressBar/Spinner.js";

function EditReperto() {
  const { repertoId, setRepertiFilter, userProfile } = useAppContext();
  const [isMenuActive, setMenuActive] = useState(false);
  const { pathname } = useLocation();
  const organization = JSON.parse(localStorage.getItem("organization"));
  const navigate = useNavigate();
  const [formData, setFormData] = useState();
  const [issues, setIssues] = useState([]);
  const [showIssues, setShowIssues] = useState(false);
  const [immagini, setImmagini] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleFormDataChange = (key, value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [key]: value,
    }));
  };

  const userCanWrite = userHasPermission({
    userProfile,
    organization,
    resource: "REPERTO",
    resourceGroups: formData?.groups,
    permission: "WRITE",
  })


  // ****************************************************************************************************
  // ALL API CALLS

  const fetchReperto = async (id) => {
    try {
      let data = await getReperto(id);
      data.provenienze = data.provenienze.map((provenienza) => ({
        ...provenienza,
        comuneId: provenienza.comune.id,
      }));
      setFormData({ ...data });
      setImmagini(data.immagini);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate("/");
        console.error("Unauthorized. Redirecting you to the login page...");
      } else {
        console.error(`Error fetching "reperto" record`, error);
      }
    }
  };



  const editReperto = async (data) => {
    try {
      await updateReperto(data);
      toast.success("Reperto aggiornato con successo!");
    } catch (error) {
      if (error.respomse && error.response.status === 401) {
        navigate("/");
        console.error(`Authorization error updating a "reperto" record`);
      } else {
        toast.error(
          error.response && error.response.detail
            ? error.response.detail
            : `Unknown error updating a "cassetta" record`
        );
        console.error(`Authorization error updating a "reperto" record`, error);
      }
    }
  };

  //* ****************************************************************************************************
  // ALL EFFECTS

  // FETCHINT THE SELECTED REPERTO FROM BE
  useEffect(() => {
    if (repertoId) fetchReperto(repertoId);
  }, [repertoId]);

  useEffect(() => {
    if (!formData) return;
    let issues = validateReperto(formData);
    setIssues(issues);
  }, [formData]);

  // ****************************************************************************************************
  // ALL HANDLERS

  const handleChangeImmagini = useCallback((val) => {
    setImmagini(val);
  }, []);

  const handleSaveImageRef = async () => {
    try {
      if (!immagini || immagini.length === 0) return;
      const submitData = immagini
        .filter(
          (img) =>
            !formData.immagini
              .map((item) => item.immagineId)
              .includes(img.immagineId)
        )
        .map((img) => ({
          immagineId: img.immagineId,
          repertoId: formData.id,
        }));


      await Promise.all(submitData.map((img) => saveRepertoImg(img)));
      toast.success("Immagini salvate con successo!");
    } catch (err) {
      console.log(err);
      toast.error("Errore nel salvataggio delle immagini");
    }
  };

  const handleSave = async () => {
    if (issues.length > 0) {
      setShowIssues(true);
      return;
    }
    setIsLoading(true);
    try {
      let reperto = {
        ...formData,
        groups: formData.groups.map((group) => group.id), 
        codiciInventario: formData.codiciInventario.map((c) => ({
          tipo: c.tipo,
          codice: c.codice,
        })),
        raccoltaId: formData.raccolta ? formData.raccolta.raccoltaId : null,
      };
      delete reperto.immagini;
      await updateRepertoEsposizione(reperto.esposizione? { id: reperto.id, locationId: reperto.esposizione.id } : { id: reperto.id, locationId: null });
      await handleSaveImageRef();
      await editReperto(reperto);
    } catch (err) {
      console.error("Error saving reperto", err);
      toast.error("Errore nel salvataggio del reperto");
    } finally {
      setRepertiFilter([]); // Reset the filter
      setIsLoading(false);
      navigate(-1);
    }
  };



  // ****************************************************************************************************

  const disabled = pathname !== "/reperti/edit";
  const repertiRecordDetailsBreadcrumbs = [
    {
      id: 1,
      label: "Dati Archeologici",
      iconUrl: true,
    },
    {
      id: 2,
      label: "REPERTI",
      iconUrl: true,
    },
    { id: 3, label: "Dettaglio reperto", iconUrl: "" },
  ];
  const subHeaderRightNavOptions = {
    icons: disabled
      ? [
          {
            icon: <RightArrowIcon fillColor="var(--archeo-color)" className="reverted-edit-icon" />,
            onClick: () => {
              navigate(-1);
            },
            label: "Indietro",
          },
          userCanWrite && {
            icon: <EditIcon fillColor="var(--archeo-color)" />,
            onClick: () => {
              navigate("/reperti/edit");
            },
            label: "Edita",
          },
        ]
      : [],

    components: disabled
      ? []
      : [
          <button onClick={() => navigate(-1)} className="cancel-button">
            <div className="login-icon">
              <CrossIcon />
            </div>
            <span className="login-text">Annulla</span>
          </button>,
          <button onClick={handleSave} className="save-button">
            <AddIcon fillColor="#fff" />
            <span className="login-text">Salva</span>
          </button>,
        ],
  };
  return (
    <>
      <div className="container">
        <main className="record-detail-main-content">
          <DataTableSubHeader
            title={"Dettagli reperto"}
            breadcrumbsData={repertiRecordDetailsBreadcrumbs}
            subHeaderRightNavOptions={subHeaderRightNavOptions}
            isMenuActive={isMenuActive}
            setMenuActive={() => setMenuActive(!isMenuActive)}
          />
          <RepertiRecordDetailForm
            data={formData}
            immagini={immagini}
            onChangeImmagini={handleChangeImmagini}
            setData={setFormData}
            onFieldChange={handleFormDataChange}
            disabled={disabled}
            issues={issues}
            showIssues={showIssues}
          />
        </main>
        {isMenuActive && (
          <SubHeaderMobileOption
            buttons={subHeaderRightNavOptions?.components}
            icons={subHeaderRightNavOptions?.icons}
            onCrossClick={() => setMenuActive(false)}
            title="options"
          />
        )}
        {isLoading && <Spinner />}
      </div>
    </>
  );
}

export default EditReperto;
